<div class="frame-clip">
  <iframe [src]="privacyUrl" class="privacy-frame"></iframe>
</div>
